/**
 * 全体で共通で使われる定数管理
 */
export const CAR_TYPES = [
  {
    name: 'A110 GTS',
    id: 'a110gts',
  },
  {
    name: 'A110 R 70',
    id: 'a110r',
  },
];